import React from 'react';
import {Field} from 'formik';
import {unstable_batchedUpdates} from 'react-dom';
import DataItemRadio from '../../../_common/components/DataItemRadio';
import styles from './styles.module.scss';
import {Validation} from "../../../../../utils";

const RadioSelectAll = ({rows, type, label}) => {
  const selectedPrefix = type === 'type-1' ? '1-' : '8-';
  const otherPrefix = type === 'type-1' ? '8-' : '1-';

  const handleChange = (form, currentType) => {
    const isCurrentlyActive = currentType === type;

    unstable_batchedUpdates(() => {
      rows.forEach(item => {
        const id = String(item._id);
        const canSelect = !isCurrentlyActive
          && (item.status === 1 || item.status === 4)
          && item.canCreate
          && Validation.canSendInvoiceOrderToRivhit(new Date(item.createdAt))
          && (type === 'type-8' ? item.allowInvoiceDeal : true);

        form.setFieldValue(`${selectedPrefix}${id}`, canSelect, false);
        form.setFieldValue(`${otherPrefix}${id}`, false, false);
      });

      form.setFieldValue('types', isCurrentlyActive ? '' : type, false);
    });
  };

  return (
    <div className={styles.container}>
      <Field name="types">
        {({field, form}) => (
          <DataItemRadio
            type="checkbox"
            fieldName="types"
            id={type}
            checked={field.value === type}
            onChange={() => handleChange(form, field.value)}
            label={label}
            customLabelStyle={styles.buttonLabel}
          />
        )}
      </Field>
    </div>
  );
};

export default RadioSelectAll;